import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactFC from 'react-fusioncharts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import Scatter from 'fusioncharts/fusioncharts.charts';
import FusionCharts from 'fusioncharts';
import useApi, { GET_MONTHLY_CORRELATION_DATA } from 'hooks/useApi';
import LoadingSpinner from 'components/LoadingSpinner';

ReactFC.fcRoot(FusionCharts, Scatter, FusionTheme);

const ScatterChart = React.forwardRef(({ id, isLegendDisplayed }, ref) => {
  const [responseState, makeRequest] = useApi();
  const { isLoading, isError, data, error } = responseState;

  useEffect(() => {
    if (isLoading || (isError && error)) {
      return;
    }

    if (!data) {
      const params = GET_MONTHLY_CORRELATION_DATA({ id });
      makeRequest(params);
    }
  }, [id, makeRequest, data, error, isError, isLoading]);

  const getDataSource = () => {
    return {
      chart: {
        yAxisName: 'Period Values',
        xAxisName: 'Dates',
        theme: 'fusion',
        numberSuffix: '%',
        showLegend: isLegendDisplayed,
        exportShowMenuItem: false,
        exportEnabled: true,
        exportFormats: "PNG|PDF|CSV|SVG"
      },

      dataset: data.datasets.map(dataset => ({
        seriesname: dataset.name,
        showRegressionLine: '1',
        data: dataset.data.map(item => ({
          x: item.value.x * 100,
          y: item.value.y * 100
        }))
      }))
    };
  };

  const dataSource = data && getDataSource();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ReactFC
      ref={ref}
      type="scatter"
      width="100%"
      height="500"
      dataFormat="json"
      dataSource={dataSource}
    />
  );
});

ScatterChart.propTypes = {
  id: PropTypes.string,
  isLegendDisplayed: PropTypes.bool
};

ScatterChart.defaultProps = {
  id: null,
  isLegendDisplayed: true
};

export default ScatterChart;
